var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align--center justify--space-between"},[_c('button',{staticClass:"btn btn-sm btn btn-info",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n        Buscar\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }